import { render, staticRenderFns } from "./huahua-kids.vue?vue&type=template&id=5639f988&scoped=true&"
import script from "./huahua-kids.vue?vue&type=script&lang=js&"
export * from "./huahua-kids.vue?vue&type=script&lang=js&"
import style0 from "./huahua-kids.vue?vue&type=style&index=0&id=5639f988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639f988",
  null
  
)

export default component.exports